const headerLinks = {
	sportsbook: '/sportsbook',
	casino: '/casino',
	'live-casino': '/live-casino',
	virtuals: '/sportsbook',
	'we-spin': '/we-spin'
} as const;

type Products = keyof typeof headerLinks;

const getHeaderLink = (link: Products) => {
	return headerLinks[link] || '';
};

export default getHeaderLink;
